// @flow
import React, { useState } from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { Text, Icon, Row, Col, Card } from '../';
import ModalHeader from './ModalHeader';

type Props = {
  modalFooter?: Element,
  modalHeaderType: string,
  children: Element,
  backdrop?: true | false | 'static',
  title?: String,
  secondary?: Boolean,
  isOpen: boolean,
  toggle: Function,
  rightTitle?: boolean,
};

CustomModal.defaultProps = {
  modalHeaderType: 'blackText',
  rightTitle: false,
};

export default function CustomModal(props: Props) {
  const {
    modalFooter = false,
    toggle,
    rightTitle,
    children,
    backdrop = 'static',
    title,
    modalHeaderType,
    iconColor = "blackText",
    ...restProps
  } = props;
  return (
    <Modal
      isOpen={props.isOpen}
      toggle={toggle}
      backdrop={backdrop}
      contentClassName="bg-white radius-md p-2"
      {...restProps}
    >
      <Card className="overflow-hidden" hasShadow={false}>
        <ModalHeader>
          <Card type={modalHeaderType} className="row h-100 align-items-center">
            <Col
              xs={rightTitle ? 4 : 2}
              className="d-flex justify-content-center"
            >
              {rightTitle ? (
                <Text color="primary" size="md">
                  {title}
                </Text>
              ) : null}
            </Col>
            <Col
              xs={!rightTitle ? 8 : 6}
              className="d-flex justify-content-center"
            >
              {!rightTitle ? (
                <Text color="white" size="md">
                  {title}
                </Text>
              ) : null}
            </Col>
            <Col
              xs={2}
              className="d-flex pointer justify-content-center align-self-start pt-3 p-0"
              onClick={toggle}
            >
              <Icon name="e-remove" color={iconColor} size={16} />
            </Col>
          </Card>
        </ModalHeader>
        <Card
          type="transparent"
          className="overflow-hidden"
          hasShadow={false}
          hasRadius={false}
        >
          <ModalBody className="p-0">{children}</ModalBody>
        </Card>
        {modalFooter ? (
          <ModalFooter className="p-0">{modalFooter}</ModalFooter>
        ) : null}
      </Card>
    </Modal>
  );
}
